import type { URLParams } from '@archipro-website/top-navigation';

/** True when the URL carries an explicit sort (path segment or query param). */
export const hasSortParam = (params: URLParams): boolean => {
    const sort = params.sort;
    if (Array.isArray(sort)) {
        return sort.some(Boolean);
    }

    return sort !== undefined && sort !== null && String(sort) !== '';
};
